import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Grid,
  FormControl,
  Flex,
  Box,
  Radio,
  Stack,
  RadioGroup,
  ModalFooter,
  FormLabel
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { BiSliderAlt } from 'react-icons/bi'

import useConciliation from '@hook/budget/user-conciliation'
const BudgetConciliationModalEdit: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { selecteds, setTypeSelecteds } = useConciliation()
  const [type, setType] = useState('')

  return (
    <>
      <Button
        fontSize={14}
        size="sm"
        color="#4b64c9"
        borderRadius={5}
        border="1px solid #4b64c9"
        cursor="pointer"
        disabled={selecteds.length === 0}
        transition="all ease .2s"
        _hover={{
          background: '#c0d9ff',
          color: '#2d3b72'
        }}
        onClick={onOpen}
      >
        Editar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
        <ModalOverlay />
        <ModalContent background={'white'} marginX={[4, 8, 16]}>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Parametros de Abastecimento
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <Grid templateColumns="repeat(2, 1fr)" gap={6}>
              <FormControl isRequired>
                <FormLabel fontWeight="bold">
                  Registros Selecionados: {selecteds.length}
                </FormLabel>
                <RadioGroup onChange={value => setType(value)} value={type}>
                  <Stack>
                    <Radio borderColor="black" value="0">
                      Conciliação
                    </Radio>
                    <Radio borderColor="black" value="1">
                      Operações
                    </Radio>
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Grid>
          </ModalBody>
          <ModalFooter bg="white">
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                setTypeSelecteds(type)
                onClose()
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default BudgetConciliationModalEdit
